import { useEffect, useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import Modal from "../../layouts/Modal";

interface AddToWorkOrderChooserModalProps {
  open: boolean;
  onClose: () => void;
  onCreateNew: () => void;
  onAddToExisting: () => void;
  selectedCount: number;
}

export default function AddToWorkOrderChooserModal({
  open,
  onClose,
  onCreateNew,
  onAddToExisting,
  selectedCount,
}: AddToWorkOrderChooserModalProps) {
  const [selection, setSelection] = useState<"create" | "existing">("create");

  useEffect(() => {
    if (open) setSelection("create");
  }, [open]);

  return (
    <Modal open={open} setOpen={(isOpen) => { if (!isOpen) onClose(); }} width="max-w-xl">
      <div className="relative px-2 pb-2">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-0 top-0 rounded-md p-1 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        <div className="pt-2 text-center">
          <h2 className="text-xl font-semibold text-gray-900">Add to Work Order</h2>
          <p className="mt-2 text-base text-gray-600">
            {selectedCount} selected item{selectedCount === 1 ? "" : "s"}
          </p>
        </div>

        <div className="mt-6 rounded-xl border border-gray-200 divide-y divide-gray-200">
          <label className="flex cursor-pointer items-start gap-3 p-4">
            <input
              type="radio"
              name="work-order-choice"
              checked={selection === "create"}
              onChange={() => setSelection("create")}
              className="mt-1 h-5 w-5 text-primary-600"
            />
            <div>
              <p className="text-xl font-semibold text-gray-900">Create new work order</p>
              <p className="mt-1 text-base text-gray-600">Create a new work order using the selected items.</p>
            </div>
          </label>

          <label className="flex cursor-pointer items-start gap-3 p-4">
            <input
              type="radio"
              name="work-order-choice"
              checked={selection === "existing"}
              onChange={() => setSelection("existing")}
              className="mt-1 h-5 w-5 text-primary-600"
            />
            <div>
              <p className="text-xl font-semibold text-gray-900">Add to existing work order</p>
              <p className="mt-1 text-base text-gray-600">Use an existing work order.</p>
            </div>
          </label>
        </div>

        {/* <div className="mt-6 flex flex-col items-center gap-3"> */}
        <div className="mt-6 flex justify-between gap-4">
          <ButtonInput
            label="Cancel"
            isSubmit={false}
            onClick={onClose}
            classes="!bg-gray-200 !text-gray-700 hover:!bg-gray-300"
          />

          <ButtonInput
            label={selection === "create" ? "Create new work order" : "Add to existing work order"}
            isSubmit={false}
            onClick={() => (selection === "create" ? onCreateNew() : onAddToExisting())}
            classes="w-full max-w-lg"
          />
        </div>
      </div>
    </Modal>
  );
}
